import * as PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import buedingenLogo from '../../assets/buedingen-logo.png';
import { IconBookmarkOutline, IconMap, IconNewsPaper, IconNotificationsOutline } from '../Icons';

const Tipps = ({ onClickPartner }) => {
  const { t } = useTranslation('components');

  return (
    <>
      <h2 className="font-semibold text-xl mt-8 text-slate-500">
        {t('physician_welcome_screen.tipps.title', {
          allowHtml: true,
        })}
      </h2>
      <div className="lg:flex justify-between mt-4 w-full">
        <div className="flex w-full border lg:mr-2 p-4">
          <div className="flex p-1 rounded-full justify-center items-center bg-slate-200 mr-4 h-12 w-12 flex-shrink-0">
            <IconNewsPaper className="fill-current text-slate-500" />
          </div>
          <div>
            <h3 className="font-semibold">{t('physician_welcome_screen.tipps.faqs.title')}</h3>
            <div className="mb-4">{t('physician_welcome_screen.tipps.faqs.text')}</div>
            <div className="text-blue-500 hover:underline">
              {t('physician_welcome_screen.tipps.faqs.link', {
                allowHtml: true,
              })}
            </div>
          </div>
        </div>
        <div className="flex w-full border lg:ml-2 p-4 mt-4 lg:mt-0">
          <div className="flex p-1 rounded-full justify-center items-center bg-slate-200 mr-4 h-12 w-12 flex-shrink-0">
            <IconBookmarkOutline className="fill-current text-slate-500" />
          </div>
          <div>
            <h3 className="font-semibold">{t('physician_welcome_screen.tipps.shortcut.title')}</h3>
            <div className="mb-4">{t('physician_welcome_screen.tipps.shortcut.text')}</div>
            <div className="text-blue-500 hover:underline">
              {t('physician_welcome_screen.tipps.shortcut.link', {
                allowHtml: true,
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="lg:flex justify-between mt-4 w-full">
        <div className="flex w-full border lg:mr-2 p-4">
          <div className="flex p-1 rounded-full justify-center items-center bg-slate-200 mr-4 h-12 w-12 flex-shrink-0">
            <IconMap className="fill-current text-slate-500" />
          </div>
          <div>
            <h3 className="font-semibold">
              {t('physician_welcome_screen.tipps.notifications.title')}
            </h3>
            <div className="mb-4">
              {t('physician_welcome_screen.tipps.notifications.text', {
                allowHtml: true,
              })}
            </div>
            <div className="text-blue-500 hover:underline">
              {t('physician_welcome_screen.tipps.notifications.link', {
                allowHtml: true,
              })}
            </div>
          </div>
        </div>
        <div className="flex w-full border lg:ml-2 p-4 mt-4 lg:mt-0">
          <div className="flex p-1 rounded-full justify-center items-center bg-slate-200 mr-4 h-12 w-12 flex-shrink-0">
            <IconNotificationsOutline className="fill-current text-slate-500" />
          </div>
          <div>
            <h3 className="font-semibold">
              {t('physician_welcome_screen.tipps.contact_page.title')}
            </h3>
            <div className="mb-4">{t('physician_welcome_screen.tipps.contact_page.text')}</div>
            <div className="text-blue-500 hover:underline">
              {t('physician_welcome_screen.tipps.contact_page.link', {
                allowHtml: true,
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="lg:flex justify-between mt-4 w-full">
        <div className="flex w-full border lg:mr-2 p-4">
          <div className="w-32 lg:w-20 mr-4 flex items-center">
            <img alt="buedingen med logo" src={buedingenLogo} className="object-contain" />
          </div>
          <div>
            <h3 className="font-semibold">{t('physician_welcome_screen.tipps.partner.title')}</h3>
            <div className="mb-4">
              {t('physician_welcome_screen.tipps.partner.text', {
                allowHtml: true,
              })}
            </div>
            <button
              className="text-blue-500 hover:underline cursor-pointer"
              onClick={e => {
                e.preventDefault();
                onClickPartner();
              }}
              type="button"
            >
              {t('physician_welcome_screen.tipps.partner.link', {
                allowHtml: true,
              })}
            </button>
          </div>
        </div>
        <div className="w-full lg:ml-2 p-4 mt-4 lg:mt-0" />
      </div>
    </>
  );
};

Tipps.defaultProps = {
  onClickPartner: () => {},
};

Tipps.propTypes = {
  onClickPartner: PropTypes.func,
};

export default Tipps;
